import * as types from 'actions/actionTypes';
import {beginAjaxCall, ajaxCallError, ajaxCallErrorButNotFound} from './ajaxStatusActions';
import * as services from 'services/apis/calAmp/icnServices';
import {getPredictiveImage} from './crashboxxServicesActions';
import * as toastr from '../../node_modules/toastr/build/toastr.min.js';
var I18n = require('react-redux-i18n').I18n;

/**
 * action per la ricerca
 */

export function getSearchICNListCancelSource(){
    var source = services.getSearchICNListCancelSource();
    return source;
}

export function cancelSearchICNListRequest(source){
    services.cancelSearchICNList(source);

    return {type: types.SEARCH_ICNLIST_CANCELREQUEST}
}

export function searchICNListRequest(){
    return {type: types.SEARCH_ICNLIST_REQUEST}
}

export function searchICNListSuccess(data){
    return {type: types.SEARCH_ICNLIST_SUCCESS, data}
}

export function searchICNListError(){
    return {type: types.SEARCH_ICNLIST_ERROR}
}

/**
 * ricerca lista icn
 * @param {filtri di ricerca} data
 * @param {impginazione e sort} pagination
 */
export const searchICNList = (data, pagination, cancelToken) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(searchICNListRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.searchICNList(data.icnId, data.selectedDeviceIdType, data.deviceFilterValue, data.vin, data.dateFrom, data.dateTo, data.selectedSeverityValues,
        data.device, data.vehicle, data.selectedAccount, data.selectedClassificationValue, data.includeSubAccount,
        pagination.sortName, pagination.isDescending,
        pagination.currentPage, pagination.selectedPageSize, cancelToken)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(searchICNListSuccess(response.data.response));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(searchICNListError());
    });
}

/*
    actions per la ricerca di ICN da mostrare sulla mappa
*/

export function searchMapICNListRequest(){
    return {type: types.SEARCH_MAPICNLIST_REQUEST}
}

export function searchMapICNListWithParamsRequest(){
    return {type: types.SEARCH_MAPICNLISTWITHPARAMS_REQUEST}
}

export function searchMapICNListSuccess(data){
    return {type: types.SEARCH_MAPICNLIST_SUCCESS, data}
}

export function searchMapICNListError(){
    return {type: types.SEARCH_MAPICNLIST_ERROR}
}

/**
 * ricerca lista icn da caricare sulla mappa
 * @param {filtri di ricerca} data
 * @param {impginazione e sort} pagination
 */
export const searchMapICNList = () => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(searchMapICNListRequest());
    dispatch(beginAjaxCall());

    var dateTo = new Date();
    var dateFrom = new Date();
    dateFrom.setMonth(dateFrom.getMonth() - 6);

    var severityList = ["VeryLight","Light","Moderate","Heavy","VeryHeavy"];

    // restituisce una promise
    services.fetchAllICNList(dateFrom, dateTo, severityList)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(searchMapICNListSuccess(response.data.response));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(searchMapICNListError());
    });
}

/**
 * ricerca lista icn da caricare sulla mappa
 * @param {filtri di ricerca} data
 * @param {impginazione e sort} pagination
 */
export const searchMapICNListWithParams = (data) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(searchMapICNListWithParamsRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.fetchAllICNListBySearch(data.icnId, data.selectedDeviceIdType, data.deviceFilterValue, data.vin, data.dateFrom, data.dateTo, data.selectedSeverityValues,
        data.device, data.vehicle, data.selectedAccount, data.selectedClassificationValue, data.includeSubAccount)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(searchMapICNListSuccess(response.data.response));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(searchMapICNListError());
    });
}

/*
    action per la ricerca singolo ICN
*/

export function getIcnRequest(){
    return {type: types.GET_ICNITEM_REQUEST}
}

export function getIcnSuccess(data){
    return {type: types.GET_ICNITEM_SUCCESS, data}
}

export function getIcnError(){
    return {type: types.GET_ICNITEM_ERROR}
}

/**
 * ricerca icn per id
 * @param {icn id} id
 */
export const getIcn = (id) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getIcnRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getIcnById(id)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(getIcnSuccess(response.data.response.results[0]));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getIcnError());
    });
}



export function getIcnPlusRequest(){
    return {type: types.GET_ICNPLUS_REQUEST}
}

export function getIcnPlusSuccess(data){
    return {type: types.GET_ICNPLUS_SUCCESS, data}
}

export function getIcnPlusError(){
    return {type: types.GET_ICNPLUS_ERROR}
}

/**
 * ricerca icn plus per id
 * @param {icn id} id
 */
export const getIcnPlus = (id, callPredictive) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getIcnPlusRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getIcnPlusById(id, callPredictive)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            var data = response.data.response.results[0];
            dispatch(getIcnPlusSuccess(data));

            if(data && data.icnplus && callPredictive)
            {
                dispatch(getPredictiveImage(data.icnplus.pdof, data.icnplus.severityCode, data.icnplus.vehicleClass));
            }

        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getIcnPlusError());
    });
}



export function getIcnSpeedRequest(){
    return {type: types.GET_ICNSPEED_REQUEST}
}

export function getIcnSpeedSuccess(data){
    return {type: types.GET_ICNSPEED_SUCCESS, data}
}

export function getIcnSpeedError(){
    return {type: types.GET_ICNSPEED_ERROR}
}

/**
 * ricerca icn speed per id
 * @param {icn id} id
 */
export const getIcnSpeed = (id) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getIcnSpeedRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getIcnSpeed(id)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(getIcnSpeedSuccess(response.data.response.results));
        })
        .catch(error => {
            dispatch(ajaxCallErrorButNotFound(error));
            dispatch(getIcnSpeedError());
    });
}


export function getIcnAccelerationRequest(){
    return {type: types.GET_ICNACCELERATION_REQUEST}
}

export function getIcnAccelerationSuccess(data){
    return {type: types.GET_ICNACCELERATION_SUCCESS, data}
}

export function getIcnAccelerationError(){
    return {type: types.GET_ICNACCELERATION_ERROR}
}

/**
 * ricerca icn Acceleration per id
 * @param {icn id} id
 */
export const getIcnAcceleration= (id) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getIcnAccelerationRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getIcnAcceleration(id)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(getIcnAccelerationSuccess(response.data.response.results));
        })
        .catch(error => {
            dispatch(ajaxCallErrorButNotFound(error));
            dispatch(getIcnAccelerationError());
    });
}



export function getBomListRequest(){
    return {type: types.GET_BOMLIST_REQUEST}
}

export function getBomListSuccess(data){
    return {type: types.GET_BOMLIST_SUCCESS, data}
}

export function getBomListError(){
    return {type: types.GET_BOMLIST_ERROR}
}

/**
 * ricerca icn Acceleration per id
 * @param {icn id} id
 */
export const getBomList= (id) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getBomListRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getBillOfMaterials(id)
        .then(response => {
            /*
                operazione avvenuta con successo
            */
            var dentData = response.data.response.results.dentdata;
            var list = [];
            if(dentData)
            {
                list = dentData.dentdetails;
            }
            dispatch(getBomListSuccess(list));
        })
        .catch(error => {
            dispatch(ajaxCallErrorButNotFound(error));
            dispatch(getBomListError());
    });
}


export function sendEventClassificationUpdateRequest(){
    return {type: types.SEND_EVENTCLASSIFICATIONUPDATE_REQUEST}
}

export function sendEventClassificationUpdateSuccess(){
    return {type: types.SEND_EVENTCLASSIFICATIONUPDATE_SUCCESS}
}

export function sendEventClassificationUpdateError(){
    return {type: types.SEND_EVENTCLASSIFICATIONUPDATE_ERROR}
}


/**
 * eseguo update della event classification
 * @param {icn id} id
 */
export const sendEventClassificationUpdate = (id, classification) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(sendEventClassificationUpdateRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.updateEventClassification(id, classification)
        .then(response => {
            toastr.success(I18n.t('GLOBAL.operationSuccess'));
            dispatch(sendEventClassificationUpdateSuccess());
        })
        .catch(error => {
            dispatch(ajaxCallErrorButNotFound(error));
            dispatch(sendEventClassificationUpdateError());
    });
}


// WEBPACK FOOTER //
// ./src/actions/icnActions.js